import { FC, useMemo } from "react";
import { GetAvatar } from "Utils/generateThumbnail";
import { IUserData } from "Data/interfaces/User/IUserData";
import { Container } from "./styles";
import { Icon } from "Components/UI";
import Ellipsis from "Components/UI/Ellipsis";
import AccessPermission from "Utils/AcessPermission";

interface ICardUser {
  user: IUserData;
  isAssigned?: boolean;
  isYou?: boolean;
  isFollower?: boolean;
  toggleFollowers: (userIds: IUserData[], add: boolean) => void;
}

const CardUser: FC<ICardUser> = ({
  user,
  isAssigned,
  isYou,
  isFollower,
  toggleFollowers,
}) => {
  const maxLength = useMemo(() => {
    const base = isFollower ? 25 : 27;
    if (isYou && isAssigned) return base - 9;
    if (isYou) return base - 5;
    if (isAssigned) return base - 7;
    return base;
  }, [isYou, isAssigned, isFollower]);

  const hasPermission = AccessPermission.isAdmin() || AccessPermission.isCoordenador();

  const handleToggleFollowers = () => {
    if (!hasPermission || isYou) {
      return;
    }

    toggleFollowers([user as IUserData], !isFollower);
  }

  return (
    <Container
      isyou={isYou}
      haspermission={hasPermission}
      onClick={handleToggleFollowers}
    >
      <div className="cardUserLeft">
        <GetAvatar
          src={user?.OriginalImageUrl}
          thumbSrc={user?.ThumbnailImageUrl}
          name={user?.Nome || ''}
          size={24}
        />
        <Ellipsis
          phrase={user?.Nome || ''}
          maxLength={maxLength}
          className="cardUserText"
        />
        {isYou && (
          <span className="tagAssigned">Você</span>
        )}
        {isAssigned && (
          <span className="tagAssigned">Responsável</span>
        )}
      </div>
      <div className="cardUserRight">
        {isFollower && (
          <>
            <Icon
              icon="eyeCheck"
              customSize={16}
              className="cardUserIconEyeCheck"
            />
            <Icon
              icon="cancelar"
              customSize={10}
              className="cardUserIconCancelar"
            />
          </>
        )}
        {!isFollower && (
          <Icon
            icon="adicionar"
            customSize={22}
            className="cardUserIconAdd"
          />
        )}
      </div>
    </Container>
  )
}

export default CardUser;
